module.exports = __webpack_public_path__ + "img/23.b94260f3.jpg";